import { FC } from 'react';

import Box from '@mui/material/Box/Box';

import { CardType, CardTitle, CardDescription, CardText } from './Card.styles';

import { TCardProps } from 'types/common';
import { colors } from 'styles';

const Card: FC<TCardProps> = ({
  description,
  title,
  type,
  image,
  postUrl,
  author,
  authorImage,
  linkedInAuthorLink,
  minutesOfRead,
  publishDate,
  needImageBg = false,
}) => {
  return (
    <a href={postUrl} style={{ textDecoration: 'none', color: 'inherit' }}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        height="100%"
        width="100%"
        sx={{
          border: '1px solid rgba(97, 97, 97, 1)',
          borderRadius: '8px',
          overflow: 'hidden',
          cursor: 'pointer',
          ':hover': {
            border: '1px solid blue',
            boxShadow: '4px 4px 20px 0px #257DD666',
          },
        }}
      >
        {needImageBg && (
          <Box
            sx={{
              width: '100%',
              height: '300px',
              background: colors.mainDark,
              flex: '0 0 300px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={image}
              alt="article"
              style={{
                width: '100%',
                objectFit: 'cover',
                display: 'block',
                maxHeight: '300px',
              }}
            />
          </Box>
        )}

        {!needImageBg && (
          <Box
            sx={{
              width: '100%',
              '& img': {
                display: 'block',
                width: '100%',
                height: '300px',
                objectFit: 'cover',
              },
            }}
          >
            <img src={image} alt="article" />
          </Box>
        )}

        <Box display="flex" flexDirection="column" padding="24px" height="100%">
          <Box flex="1 1 auto">
            <CardType>{type}</CardType>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </Box>

          <Box
            display={type === 'Article' || type === 'White Papers' ? 'flex' : 'none'}
            marginTop="32px"
          >
            <Box
              marginRight="16px"
              sx={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                '& img': {
                  maxWidth: '100%',
                  display: 'block',
                  borderRadius: '50%',
                },
              }}
            >
              <a href={linkedInAuthorLink} target="_blank" rel="noopener noreferrer">
                <img src={authorImage} alt="author" />
              </a>
            </Box>

            <Box>
              <CardText fontWeight={600}>{author}</CardText>

              <CardText>
                {publishDate} &bull; {minutesOfRead} min read
              </CardText>
            </Box>
          </Box>
        </Box>
      </Box>
    </a>
  );
};

export default Card;
